import { do_interaction } from './Analytics_Custom';
export function selectLocation({ locationCode }) {
    do_interaction(`DPH CDI|LOCATION, ${locationCode}`);
}
export function selectCategory({ categoryCode }) {
    do_interaction(`DPH CDI|CATEGORY, ${categoryCode}`);
}
export function selectIndicator({ indicators }) {
    const interaction = `DPH CDI|INDICATOR, `;

    indicators.forEach((indicator, i) => {
        do_interaction(`${interaction}${indicator}`);
    });
}
export function selectStratification({ viewBy, stratificationId }) {
    do_interaction(`DPH CDI|STRAT, ${viewBy}, ${stratificationId}`);
}
export function selectView({ vizType }) {
    do_interaction(`DPH CDI|VIEW, ${vizType}`);
}
export function selectIndicatorDefinitionLink({ indicator }) {
    do_interaction(`DPH CDI|INDDEFLINK, ${indicator}`);
}
export function selectDataSourceLink({ dataSource }) {
    do_interaction(`DPH CDI|DATALINK, ${dataSource}`);
}
export function selectViewMapLink() {
    do_interaction(`DPH CDI|VIEWMAPLINK`);
}
export function selectTopNavButton({ topNavButton }) {
    do_interaction(`DPH CDI|TOPNAV, ${topNavButton}`);
}
export function selectIndicatorDefinitions() {
    do_interaction(`DPH CDI|NAVDEF`);
}
export function selectExportPDF() {
    do_interaction(`DPH CDI|EXPORT, PDF`);
}
export function selectExportCSV() {
    do_interaction(`DPH CDI|EXPORT, CSV`);
}


    